import { Navigate, useParams } from 'react-router-dom';

import { ROUTER_PATHS } from '@/shared';
import { SaveServiceProfileComponent } from '../../shared/components/SaveServiceProfileComponent';
import { LoaderComponent } from '@/shared/components/ui';
import { useFetchProductoById } from '@/shared/actions/erp';

export interface UpdateServiceProfilePageProps { }

const UpdateServiceProfilePage: React.FC<UpdateServiceProfilePageProps> = () => {
  // useCheckPermissions(PermissionsEnum.api_change_olt);
  const returnUrlServiceProfilePage = ROUTER_PATHS.configuracionRED.serviceProfileNav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useFetchProductoById(id!, true);
  console.log({data});

  if (isLoading || isRefetching) return null;

  if (!data?.id_producto)
    return <Navigate to={returnUrlServiceProfilePage} />;

  if (isLoading) 
    return <LoaderComponent />

  return <SaveServiceProfileComponent title={`Editar Service Profile: ${data?.descripcion}`} producto={data} />;
};

export default UpdateServiceProfilePage;
